"use strict";

exports.__esModule = true;
exports.default = void 0;
var _setup = require("./_setup.js");
var _tagTester = _interopRequireDefault(require("./_tagTester.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
var _default = exports.default = _setup.nativeIsArray || (0, _tagTester.default)('Array');